import React, { FC, useEffect, useState } from "react";
import AE2Modal from "../../elements/AE2Modal";
import { IonButton, IonInput, IonItem } from "@ionic/react";
import { API_URL } from "../../../actions/settings";
import NotificationPopUp from "../../extras/NotificationPopUp";

interface IProps {
    opened:boolean,
    setOpened:any,
    date:any,
    id:string | null | undefined
};

async function updateDate(token: string,data:any,id:any) {
    return fetch(`${API_URL}/buildings/${id}/update_attribute`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(data)
    }).then((res) => {
          if (res.ok) {
            return res.json();
          }
          else{
              console.log('error')
              res.json().then( err => {
                  NotificationPopUp("Error", err, "Error Saving Date")
                  // throw error here to use the catch
              })

          }
        }).catch(error => {
          NotificationPopUp("Error", error.message, "Error Saving Date")
        });
  }

const EditPeakPerformaceDateModal:FC<IProps> = (props) => {
    const [newDate, setNewDate] = useState('')
    // eslint-disable-next-line
    const [error, setError] = useState<any>(null)
    const [updating, setUpdating] = useState(false)

    useEffect(()=>{
        setNewDate(props.date)
    },[props.date])

    const handleSave = async () =>{
        setUpdating(true)
        const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
        const data = {
            'pp_end_date':newDate
        }

        const res = await updateDate(token,data,props.id)
        setUpdating(false)
        if(res['status']==='success'){
            props.setOpened(false)
            NotificationPopUp("Success", `Peak Performance Date set to ${newDate}. Reload Page to view new percent reduction.`, "Saved Date")
            window.location.reload();
        }

    }

    return <div>
        <AE2Modal title="Edit Peak Performance End Date" opened={props.opened} setOpened={props.setOpened}>
            <div className="center-all" style={{color:'white'}}>
                <div style={{width:'100%'}}>
                    <div>Peak performance end date should be the last day of the selected month.</div>
                <IonItem lines="none" style={{width:'100%'}}>
                    <IonInput
                    label='Peak Performance Date' labelPlacement='start'
                      className={error === null ? "valid" : "ion-invalid ion-touched"}
                      type="date"
                      aria-labelledby="peak performance date"
                      value={newDate}
                      placeholder="Start Date"
                      onIonInput={(e: any) =>
                        setNewDate(e.detail.value!)
                      }
                      errorText={error}
                    />
                </IonItem>
                <IonButton disabled={updating} onClick={()=>handleSave()}>{updating ? 'Saving ...' : 'Save'}</IonButton>
                </div>
            </div>
        </AE2Modal>
    </div>
};

export default EditPeakPerformaceDateModal;